import { FC, ReactNode, createElement } from 'react';
import { AllieText, AllieTextProps } from '../../Text';
import { StatsItemStyled, StatsVariation } from './StatsItem.styles';
import { AllieIconProps } from '../../Icon';
import { AllieColors } from '../../../common/color.types';

export interface StatsItemVariationProps {
  prefix?: ReactNode;
  value: string;
  color?: AllieColors;
  textProps?: AllieTextProps;
}

export interface StatsItemProps {
  disabled?: boolean;
  icon?: React.FC<AllieIconProps>;
  iconProps?: AllieIconProps;
  valueProps: AllieTextProps;
  variation?: StatsItemVariationProps;
}

export const AllieStatsItem: FC<StatsItemProps> = ({
  disabled,
  icon,
  iconProps,
  valueProps,
  variation,
}) => (
  <StatsItemStyled
    data-testid="stats-item-container"
    style={{
      opacity: disabled ? 0.5 : 1,
    }}
  >
    {icon && createElement(icon, iconProps)}
    <AllieText {...valueProps} />
    {variation && (
      <StatsVariation color={variation.color}>
        {variation.prefix}
        <AllieText type="body2" weight={600} {...variation.textProps} color={variation.color}>
          {variation.value}
        </AllieText>
      </StatsVariation>
    )}
  </StatsItemStyled>
);
